<template>
  <div>
    <title-entities title="Serviços"></title-entities>
    <v-container fluid>
      <v-card flat class="disable-scrollbars mt-n3">
        <entidades></entidades>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Entidades from "./client/entity/Entidades";
import Title from "./geral/Title";
export default {
  name: "Entidade",
  components: {
    "title-entities": Title,
    entidades: Entidades
  },
  data: () => ({})
};
</script>

<style scoped>
.bg_header {
  background-color: #1e88e5;
  padding: 9px 0 0 10px;
}
.font {
  color: white;
  border-bottom: 2px solid white;
  /*padding-bottom: 12px;*/
}

/*#nav a{*/
/*    color: #c6c6c6;*/
/*}*/
/*#nav a.router-link-exact-active, a.router-link-active {*/
/*    color: white;*/
/*    font-weight: bold;*/
/*}*/
</style>
